/**
 * EPR – EPR reporting / declarations
 */

const eprReporting = {
  eprReport: "EPR declaration",
  country: "Jurisdiction",
  reportType: "EPR category",
  year: "Year",
  reportsEPR: "Reports EPR - Informes EPR",
  eprReporting: "EPR declarations",
  fillEPRHere: "Here you can fill your EPR declarations",
  fillEPRReport: "Fill EPR declaration",
  periodStart: "Period start",
  periodEnd: "Period end",
  totalSum: "Total amount",
  declaredQuantityKg: "Declared quantity (kg)",
  declaredQuantityKgHeaderLine1: "Declared",
  declaredQuantityKgHeaderLine2: "quantity (kg)",
  ecoFeeDue: "Eco-fee due",
  ecoFeeAmount: "Eco-fee amount",
  ecoFeeDueDate: "Eco-fee due date",
  paymentStatus: "Payment status",
  ecoFeePaymentChoice: "Eco-fee payment",
  ecoFeePaymentPaid: "paid",
  ecoFeePaymentNonPaid: "not paid",
  ecoFeePaymentStatusPaidHint: "Paid",
  ecoFeePaymentStatusNotPaidHint: "not paid",
  setEcoFeeDue: "Set Eco-fee due",
  addEPRReportToSeeData: "Add EPR report to see the data",
  addEPRReport: "Add EPR report",
  returnParameters: "Return parameters",
  editPackagingData: "Edit packaging data",
  summary: "Summary",
  name: "Name",
  glass: "Glass",
  paperPaperboardCardboard: "Paper/paperboard/cardboard",
  ferrousMetals: "Ferrous metals",
  aluminium: "Aluminium",
  plastic: "Plastic",
  beverageCartonPackaging: "Beverage carton packaging",
  otherCompositesPackaging: "Other Composites packaging",
  otherMaterials: "Other materials",
  paper: "Paper",
  steel: "Steel",
  wood: "Wood",
  numberOfScu: "Number of CSU",
  other: "Other",
  submit: "Submit",
  save: "Save",
  downloadReport: "Download report",
  back: "Back",
  warning: "Warning",
  furnitureEcoparticipations: "Furniture ecoparticipations",
  revenueExcludingVAT: "Revenue excluding VAT",
  code: "Code",
  tarifHT: "Tarif HT",
  tarifTTC: "Tarif TTC",
  codeEcopart: "Code Ecopart",
  number: "Number",
  summ: "Amount",
  category: "Category",
  product: "Product",
  material: "Material",
  feature: "Characteristic",
  addRecord: "Add Record",
  success: "Success",
  edit: "Edit",
  kg: "Kg",
  weight: "Weight",
  eprReportSuccessfullySubmitted: "EPR Report was successfully submitted!",
  eprReportSuccessfullyCreated: "EPR Report was successfully created!",
  cancel: "Cancel",
  delete: "Delete",
  areYouSureToDelete: "Are you sure you want to delete this item?",
  period: "Period",
  uploadTransactions: "Upload Transactions",
  submitDisclaimer:
    "By clicking on the Submit button you agree to the following: When you submit this EPR information you are making a legal declaration that the information is true and complete. A false declaration can result in prosecution.",
  submitDisclaimerCheckbox:
    "I have read the above and confirm that I wish to submit this declaration.",
  eprPaySubmitDraftNote:
    "Preview step (same idea as Sales Tax returns). Card charge and credits are not processed yet; Submit still sends your EPR declaration until billing is wired on the backend.",
  eprPaySubmitAutoSubmitLabel: "30 $ auto-submit",
  eprPaySubmitUseCreditsLabel: "Use credits",
  transactionsUploadInProgress: "Transactions upload is still in progress!",
  confirmMoveForwardWithUnfinishedUpload:
    "I confirm that I want to move forward with EPR report filing with transactions upload process unfinished.",
  transactionsUploadInProgressMessage:
    "Transactions upload is in progress. It may take from 5 to 30 mins for it to finish depending on the amount of your transactions.",
  noActiveIntegration:
    'No active integration. Please complete an integration in "Stores" section to be able to upload your transactions.',
  yes: "Yes",
  no: "No",
  productTypologies: "Product typologies",
  productTypology: "Product typology",
  editTextileData: "Edit textile data",
  clothing: "Clothing",
  householdLinen: "Household linen",
  footwear: "Footwear",
  selectDeclarationMethod: "Available declaration methods",
  detailedDeclaration: "Detailed declaration",
  fourTypesOfReportingParameters:
    "4 types of reporting parameters for each item",
  volumesDeclaredPerProductLine: "Volumes declared per product line",
  standardScale: "Standard scale",
  simplifiedDeclaration: "Simplified declaration",
  twoStepsDeclaration: "2 steps declaration",
  volumesDeclaredPerProductFamily:
    "Volumes declared per product family (Clothing, Household linen, Footwear)",
  pricePerItemIncreased: "Price per item is increased",
  revenue: "Revenue",
  tax: "Tax",
  fee: "Fee",
  productDescription: "Product description",
  uploadPaymentMemo: "Upload payment memo file",
  quantity: "Quantity",
  quantityIntegerOnly: "Only whole numbers allowed",
  fieldRequired: "This field is required",
  skip: "Skip",
  totalWeightKg: "Total weight (Kg)",
  quantityWithoutBreakdownNote:
    "Quantity – (without per-category breakdown for the Netherlands)",
  selectPackagingCategories: "Select packaging categories",
  emptyState: {
    noSubscription: {
      title: "No active EPR subscriptions",
      description: "You currently don't have any active EPR subscriptions.\nGet started by purchasing a subscription to access\nEPR guides and reporting tools.",
      cta: "Get subscription",
    },
  },
};

export default eprReporting;
